export enum ActionTypes {
  AddExpertServiceImplementationRequest = 'addExpertServiceImplementation.request',
  AddExpertServiceImplementationSuccess = 'addExpertServiceImplementation.success',
  AddExpertServiceImplementationFailure = 'addExpertServiceImplementation.failure',
}
